import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("button", {
    onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('on-click'))),
    class: ["focus:outline-none focus:shadow-outline transition duration-150", {
			'bg-white hover:bg-gray-100 active:bg-gray-200 text-gray-700 border-gray-400 border':
				_ctx.buttonColor === 'default' && !_ctx.isDisabled,
			'bg-primary hover:bg-opacity-85 active:bg-dark-primary text-white':
				_ctx.buttonColor === 'primary' && !_ctx.isDisabled,
			'bg-secondary hover:bg-opacity-85 active:bg-dark-secondary text-gray-700':
				_ctx.buttonColor === 'secondary' && !_ctx.isDisabled,
			'bg-danger hover:bg-opacity-85 active:bg-dark-danger':
				_ctx.buttonColor === 'danger' && !_ctx.isDisabled,
			'rounded-full p-2 mr-2': _ctx.fab,
			'p-1 rounded-md': _ctx.checkbox,
			'py-3 px-6 rounded-md text-sm mr-2': !_ctx.fab && !_ctx.checkbox,
			'bg-gray-400 text-gray-700 cursor-text': _ctx.isDisabled,
		}],
    disabled: _ctx.isDisabled,
    type: "button"
  }, [
    _createVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10, ["disabled"]))
}